import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Mask from "@churchofjesuschrist/eden-platform-mask";
import Lock from "@churchofjesuschrist/eden-body-lock";
import HotKey from "@churchofjesuschrist/eden-hotkey";
import { useClickBoundary } from "@churchofjesuschrist/eden-click-boundary";
import { spacing48, spacing96 } from "@churchofjesuschrist/eden-style-constants";
const ModalMask = styled(Mask).withConfig({
  componentId: "sc-1w2izfe-0"
})(["display:flex;justify-content:center;align-items:center;overflow:auto;@media (min-width:25rem){padding:", " 0;}"], spacing48);
const StyledBody = styled.div.withConfig({
  componentId: "sc-1w2izfe-1"
})(["max-height:100vh;overflow:auto;max-width:550px;@media (min-width:25rem){max-height:calc(100vh - ", ");}"], spacing96);

const Modal = _ref => {
  let {
    open,
    children
  } = _ref;
  const {
    onClose
  } = React.Children.toArray(children)[0].props;
  const clickRef = useClickBoundary({
    onClickOutside: onClose ? onClose : () => {}
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Lock, {
    active: open,
    scrollableRef: clickRef
  }), onClose ? /*#__PURE__*/React.createElement(HotKey, {
    sequence: ["Escape"],
    onMatch: onClose
  }) : null, /*#__PURE__*/React.createElement(ModalMask, {
    active: open
  }, /*#__PURE__*/React.createElement(StyledBody, {
    ref: clickRef
  }, children)));
};

export default Modal;
Modal.propTypes = {
  /** Must be a single `<Alert>`, `<Error>`, `<Info>`, `<Success>`, or `<Warn>` element from `eden-alert` to display in the modal. */
  children: PropTypes.node.isRequired,

  /** Whether modal is open */
  open: PropTypes.bool
};